import {formatCssVars} from '~/helpers'
import {Layout} from '../layout'

export const InnerAvatar = ({radius, colorSet = 'color-bordered-outline', ...rest}) => {
	return (
		<Layout
			className="eitje-avatar"
			colorSet={colorSet}
			horizontal="center"
			width={radius}
			height={radius}
			style={{...formatCssVars({radius})}}
			{...rest}
		/>
	)
}
